// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: dFGvRFSJezx
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicGetStarted2.module.css"; // plasmic-import: dFGvRFSJezx/css
import vectorsZlhptEmGP from "./images/vectors.svg"; // plasmic-import: ZlhptEmG_P/picture

createPlasmicElementProxy;

export const PlasmicGetStarted2__VariantProps = new Array();

export const PlasmicGetStarted2__ArgProps = new Array("emailText");

const $$ = {};

function PlasmicGetStarted2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"dashboardLoginDarkTheme"}
            data-plasmic-override={overrides.dashboardLoginDarkTheme}
            className={classNames(projectcss.all, sty.dashboardLoginDarkTheme)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"frame1"}
              data-plasmic-override={overrides.frame1}
              hasGap={true}
              className={classNames(projectcss.all, sty.frame1)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___5VjtR
                )}
              >
                {hasVariant(globalVariants, "screen", "mobile")
                  ? "Welcome to Astrius! "
                  : "Welcome to Astrius! Lets get started"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__egCU
                )}
              >
                {
                  "We've detected that you're currently using Astrius from a mobile device. Please login to your account from a computer so that you can fill out our your profile and start accepting payments."
                }
              </div>
              <div
                data-plasmic-name={"freeBox"}
                data-plasmic-override={overrides.freeBox}
                className={classNames(projectcss.all, sty.freeBox)}
              >
                {p.renderPlasmicSlot({
                  defaultContents:
                    "Fill out your business profile in a few minutes so that you can start accepting payments.",
                  value: args.emailText,
                  className: classNames(sty.slotTargetEmailText)
                })}
              </div>
            </p.Stack>
            <p.PlasmicImg
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={{
                src: vectorsZlhptEmGP,
                fullWidth: 1280,
                fullHeight: 111,
                aspectRatio: 11.531532
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "dashboardLoginDarkTheme", "frame1", "freeBox", "img"],
  dashboardLoginDarkTheme: [
    "dashboardLoginDarkTheme",
    "frame1",
    "freeBox",
    "img"
  ],

  frame1: ["frame1", "freeBox"],
  freeBox: ["freeBox"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGetStarted2__ArgProps,
          internalVariantPropNames: PlasmicGetStarted2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicGetStarted2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGetStarted2";
  } else {
    func.displayName = `PlasmicGetStarted2.${nodeName}`;
  }
  return func;
}

export const PlasmicGetStarted2 = Object.assign(
  // Top-level PlasmicGetStarted2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dashboardLoginDarkTheme: makeNodeComponent("dashboardLoginDarkTheme"),
    frame1: makeNodeComponent("frame1"),
    freeBox: makeNodeComponent("freeBox"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicGetStarted2
    internalVariantProps: PlasmicGetStarted2__VariantProps,
    internalArgProps: PlasmicGetStarted2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicGetStarted2;
/* prettier-ignore-end */
